import React from 'react';

const About = () => {
  return (
    <section id="about" className="section bg-white">
      <div className="container">
        <div className="max-w-4xl mx-auto">
          <div className="space-y-8">
            <div className="text-center">
              <h2 className="font-heading text-4xl font-bold text-primary-700 mb-6">
                About Dr. Adesh Palyekar
              </h2>
              <p className="text-lg text-text-muted leading-relaxed max-w-3xl mx-auto">
                Dr. Adesh Palyekar is a distinguished cancer surgeon with extensive experience in 
                treating various types of cancers. With a commitment to excellence and patient care, 
                he provides comprehensive cancer treatment using the latest medical technologies.
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="space-y-4">
                <h3 className="font-heading text-xl font-bold text-primary-700">Qualifications</h3>
                <ul className="space-y-2 text-text-muted">
                  <li className="flex items-center gap-2">
                    <i className="fas fa-graduation-cap text-accent-500"></i>
                    M.B.B.S. M.S. M.Ch.
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fas fa-medal text-gold-500"></i>
                    Gold Medalist
                  </li>
                </ul>
              </div>
              
              <div className="space-y-4">
                <h3 className="font-heading text-xl font-bold text-primary-700">Languages</h3>
                <ul className="space-y-2 text-text-muted">
                  <li className="flex items-center gap-2">
                    <i className="fas fa-language text-accent-500"></i>
                    Marathi
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fas fa-language text-accent-500"></i>
                    Konkani
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fas fa-language text-accent-500"></i>
                    Hindi
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fas fa-language text-accent-500"></i>
                    English
                  </li>
                </ul>
              </div>
              
              <div className="space-y-4">
                <h3 className="font-heading text-xl font-bold text-primary-700">Memberships</h3>
                <ul className="space-y-2 text-text-muted">
                  <li className="flex items-center gap-2">
                    <i className="fas fa-certificate text-accent-500"></i>
                    Medical Council of India
                  </li>
                </ul>
              </div>
            </div>
            
            <div className="bg-gradient-to-r from-primary-50 to-accent-50 rounded-xl p-8">
              <h3 className="font-heading text-xl font-bold text-primary-700 mb-4">
                Why Choose Dr. Palyekar?
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <ul className="space-y-2 text-text-muted">
                  <li className="flex items-start gap-2">
                    <i className="fas fa-check-circle text-medical-500 mt-1"></i>
                    <span>Expert cancer surgery with advanced techniques</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="fas fa-check-circle text-medical-500 mt-1"></i>
                    <span>Comprehensive patient care and support</span>
                  </li>
                </ul>
                <ul className="space-y-2 text-text-muted">
                  <li className="flex items-start gap-2">
                    <i className="fas fa-check-circle text-medical-500 mt-1"></i>
                    <span>State-of-the-art medical facilities</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="fas fa-check-circle text-medical-500 mt-1"></i>
                    <span>Personalized treatment plans</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 